import { useMutation } from "urql";

import { HandoverLimitRequestToCcDocument } from "../../../graphql/generated.ts";

export const useHandoverLimitRequestToCC = () =>
  useMutation(HandoverLimitRequestToCcDocument);
